// src/pages/Wallet/components/BalanceDisplay.js
import React from 'react';
import { formatPortfolioValue } from '../utils/tokenUtils';
import { useTranslation } from 'react-i18next';

const BalanceDisplay = ({ totalValue, percentChange, onClick }) => {
  const { t } = useTranslation();
  
  // Format the total value with commas and 2 decimal places
  const formattedValue = formatPortfolioValue(totalValue, 1, 2);
  
  // Determine if change is positive, negative, or null
  const hasChange = percentChange !== null && percentChange !== undefined;
  const isPositive = hasChange && percentChange >= 0;
  const formattedPercentChange = hasChange ? Math.abs(percentChange).toFixed(2) : '--';
  
  // Calculate the dollar value change based on the percentage
  const calculateDollarChange = () => {
    if (!hasChange || totalValue <= 0) return '--';
    
    // Calculate using the total value and percentage change
    const absoluteChange = totalValue * (percentChange / 100);
    return absoluteChange.toFixed(2);
  };
  
  const dollarChange = calculateDollarChange();
  const formattedDollarChange = dollarChange !== '--' ? Math.abs(parseFloat(dollarChange)).toFixed(2) : '--';
  
  return (
    <div className="portfolio-balance" onClick={onClick}>
      <h1 className="portfolio-usd">${formattedValue}</h1>
      {hasChange && (
        <div className="portfolio-changes-container">
          <div className={`portfolio-change-amount ${isPositive ? 'positive' : 'negative'}`}>
            {isPositive ? '+' : '-'}${formattedDollarChange}
          </div>
          <div className={`portfolio-change-percent ${isPositive ? 'positive' : 'negative'}`}>
            {isPositive ? (
              <>
                 +{formattedPercentChange}%
              </>
            ) : (
              <>
                 -{formattedPercentChange}%
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BalanceDisplay;